import { IHeaderParams } from '@ag-grid-community/core';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
    ArrowDown as DownArrowIcon,
    Filter as FilterIcon,
    Menu as MenuIcon,
    ArrowUp as UpArrowIcon
} from '@tassat/icon';
import React from 'react';
import ReactGA from 'react-ga4';

import { TableOptionsContext, isColumnFiltered, isColumnSorted } from 'SharedComponents/contexts/TableOptionsContext';

interface ExternalFilterHeaderProps extends IHeaderParams {
    providedField?: string;
    getMappedColumn?: (string) => string;
    getMappedTableColumn?: (string) => string;
}

const muiStyles = makeStyles({
    root: {
        height: '100%',
        width: '100%'
    },
    icon: {
        marginLeft: '.5rem',
        height: '12px',
        width: '12px'
    },
    menuIcon: {
        height: '12px',
        width: '12px'
    }
});

const ExteralFilterHeaderComponent = React.forwardRef((props: ExternalFilterHeaderProps, ref: React.Ref<any>) => {
    const {
        column,
        showColumnMenu,
        getMappedColumn,
        getMappedTableColumn
    } = props;

    const classes = muiStyles(props);
    const { TableOptions } = React.useContext(TableOptionsContext);
    const headerName = column.getUserProvidedColDef().headerName;
    const field = column.getUserProvidedColDef().field;
    let checkSenderReceiver = false;
    if (
        field === 'WalletName1' ||
        field === 'Firm' ||
        field === 'Bank'
    ) {
        checkSenderReceiver = true;
    }
    const [ showFilterIcon, setShowFilterIcon ] = React.useState(!checkSenderReceiver ?
        isColumnFiltered(field, getMappedColumn, TableOptions, getMappedTableColumn)
        : (isColumnFiltered(`recipient${field}`, getMappedColumn, TableOptions, getMappedTableColumn) ||
            isColumnFiltered(`sender${field}`, getMappedColumn, TableOptions, getMappedTableColumn)));
    const [ showSortIcon, setShowSortIcon ] = React.useState(isColumnSorted(field, getMappedColumn, TableOptions));

    const onMenuClicked = (e) => {
        showColumnMenu(e.currentTarget);
    };

    column.addEventListener('filterChanged', function(e) {
        const isFiltered = !checkSenderReceiver ?
            isColumnFiltered(field, getMappedColumn, TableOptions, getMappedTableColumn)
            : (isColumnFiltered(`recipient${field}`, getMappedColumn, TableOptions, getMappedTableColumn) ||
                isColumnFiltered(`sender${field}`, getMappedColumn, TableOptions, getMappedTableColumn));
        setShowFilterIcon(isFiltered);
        setShowSortIcon(isColumnSorted(field, getMappedColumn, TableOptions));
        if (isFiltered) {
            ReactGA.event('click', {
                event_category: 'engagement',
                event_label: `transaction_column_filter_${headerName.toLowerCase()
                    .replace(/\s+/g, '_')}`
            });
        }
    });

    return (
        <Grid
            alignItems='center'
            className={classes.root}
            container
            direction='row'
            justifyContent='space-between'
            spacing={0}
            wrap='nowrap'
        >
            <Grid
                alignItems='center'
                container
                direction='row'
                justifyContent='flex-start'
                spacing={0}
                wrap='nowrap'
            >
                <Grid item>
                    {headerName}
                </Grid>
                {showFilterIcon &&
                    <Grid item>
                        <FilterIcon
                            className={classes.icon}
                            iconColor='rgba(0, 0, 0, 0.54)'
                        />
                    </Grid>}
                {showSortIcon === 'ASC' &&
                    <Grid item>
                        <UpArrowIcon
                            className={classes.icon}
                            iconColor='rgba(0, 0, 0, 0.54)'
                        />
                    </Grid>}
                {showSortIcon === 'DESC' &&
                    <Grid item>
                        <DownArrowIcon
                            className={classes.icon}
                            iconColor='rgba(0, 0, 0, 0.54)'
                        />
                    </Grid>}
            </Grid>
            <Grid item>
                <div
                    onClick={onMenuClicked}
                    ref={ref}
                >
                    <MenuIcon
                        className={classes.menuIcon}
                        iconColor='rgba(0, 0, 0, 0.54)'
                    />
                </div>
            </Grid>
        </Grid>
    );
});

ExteralFilterHeaderComponent.displayName = 'ExteralFilterHeaderComponent';

export default ExteralFilterHeaderComponent;